// extracted by mini-css-extract-plugin
export default {"band":"StatsBand_band__KfmPR","item":"StatsBand_item__NEFv2","value":"StatsBand_value__dEi9w","label":"StatsBand_label__wAPdZ"};